import React, { useEffect, Fragment } from "react";
import { withRouter } from "react-router-dom";

const ScrollToTop = ({ history, children }) => {
  useEffect(() => {
    history.listen(() => {
      window.scrollTo({ top: 0 });
    });
  }, [history]);

  return <Fragment>{children}</Fragment>;
};

export default withRouter(ScrollToTop);
